<template>
  <div class="cso-radios-group"
       :class="{'has-error': validationErrors, 'cso-radios-group--inline': inline}">

    <label v-if="label">{{label}}</label>

    <div class="cso-radios"
         v-for="(option, index) in options"
         :key="index">

      <div class="cso-radio">
        <label :class="{'disabled': disabled}">
          <input :name="name+index"
                 v-model="currentValue"
                 type="radio"
                 @change="onInput"
                 @input="onInput"
                 :disabled="disabled || option.disabled"
                 :value="option.value" />
          <span class="label" :data-cy="option.cypressName">
            {{option.label}}
          </span>
        </label>
        <cso-info-icon v-if="option.hint"
                       :content="option.hint" />
      </div>
    </div>
    <div class="cso-radio--errors" v-if="validationErrors">
      <span v-for="(error, index) in validationErrors"
            :key="index">
        {{ error.message }}
      </span>
    </div>

  </div>
</template>
<script>
import validatedInputField from '@/mixins/validatedInputField'

import CsoInfoIcon from '@/components/core/composition/CsoInfoIcon.vue'

export default {
  name: 'CsoRadios',
  mixins: [validatedInputField],
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    inline: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  components: {
    CsoInfoIcon
  },
  methods: {
    onInput () {
      if (!!this.patternRegex && !!this.currentValue && !this.patternRegex.test(this.currentValue)) {
        this.currentValue = this.value
        return
      }

      this.$emit('update:modelValue', this.currentValue)
    }
  }
}
</script>

<style lang="scss">
.cso-radio {
  /* base radio styling */
  [type='radio'] {
    position: absolute;
    left: -9999px;

    @include print-view {
      position: relative;
      left: -27px;
    }
  }

  /* base label styling */
  label {
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    margin-top: 4px;
    margin-bottom: 4px;
    word-break: break-word;
    font-size: 18px;
    line-height: 24px;
    font-family: $font-family-regular;

    @include md {
      font-size: 16px;
    }
  }

  /* text label */
  .label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 24px;
    height: 24px;
    border: 1px solid $gray-4d;
    border-radius: 50%;
    background: #fff;
  }

  /* check mark */
  .label:after {
    content: '';
    display: block;
    position: absolute;
    background: $black;
    border-radius: 50%;
    transition: .2s ease-in-out;
    height: 10px;
    width: 10px;
    left: 7px;
    top: 7px;

    @include print-view {
      display: none;
    }
  }

  /* checked */
  [type='radio']:not(:checked) + .label:after {
    opacity: 0;
    transform: scale(0);
  }

  [type='radio']:checked + .label:after {
    opacity: 1;
    transform: scale(1);
  }

  /* focus */
  [type='radio']:focus-visible + .label:before {
    outline: 2px solid $blue;
    outline-offset: 2px;
  }

  /* disabled */
  [type='radio']:disabled + .label:before {
    border-color: $gray-f2;
    background-color: $gray-f2;
  }

  [type='radio']:disabled + .label:after {
    background-color: $black;
  }

  [type='radio']:disabled + .label {
    color: $gray-dark;
  }

  label.disabled {
    cursor: not-allowed;
  }
}

/* errors */
.cso-radios-group {
  .cso-radio--errors {
    color: $error;
    margin-bottom: 0.65em;
  }

  &.has-error [type='radio'] + .label:before {
    border: 2px solid $red-b6;
  }
}

/* info icon */
.cso-radios-group {
  .cso-info-icon:before {
    width: 28px;
    height: 28px;
    font-size: 28px;
    line-height: 22px;

    @include md {
      width: 26px;
      height: 26px;
      font-size: 26px;
      line-height: 20px;
    }
  }
}

.cso-radios-group--inline {
  & > label {
    display: block;
    margin-bottom: 5px;
  }
  .cso-radios {
    display: inline-block;
    margin-right: 10px;
  }
}
</style>
